'use strict'

loadAsyncJS = (url, args..., cb) ->
  return if not url
  [ id ] = args
  doc = window.document
  s = doc.createElement('script')
  s.defer = true
  s.src = url
  if typeof id is 'string'
    s.id = id
  if typeof cb is 'function'
    s.onload = cb
  (doc.body || doc.head).appendChild(s)
  return

# Groupon.Utils.loadAsyncJS:
module.exports = loadAsyncJS
